import React from "react"
import ApiService from "../../../Services/ApiService.js";

class JobFunctionsCheckbox extends React.Component {

    state = {
        job_functions: [],
        selected_jobs: [],
        job_function_mapping: [],
        is_loading: true

    };

    isChecked(job) {
        return this.state.selected_jobs.includes(job);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (!this.arraysEqual(prevProps.data, this.props.data)) {
            this.setSelectedJobFunctions(this.props.data)
        };

    }

    componentDidMount() {
        this.fetchJobFunctions();
    }

    fetchJobFunctions() {
        ApiService.get('/api/campaigns/fetch-job-functions').then(response => {
            let jobFunctions = response.data.job_functions;
            let jobFunctionNames = jobFunctions.map((jobFunction) => {
                return jobFunction.JobFunction;
            });

            this.setState({
                ...this.state,
                job_functions: jobFunctionNames,
                job_function_mapping: jobFunctions
            })
        }, () => {
            if (this.state.selected_jobs) {
                this.setSelectedJobFunctions();
            }
        });
    }

    setSelectedJobFunctions(selected) {
        let allJobs = this.state.job_functions;
        let jobMapping = this.state.job_function_mapping;
        let selectedJobs = selected;

        if (allJobs.length > 0) {
            if (selectedJobs.every(selectedJob => typeof selectedJob === 'number')) {
                selectedJobs = selectedJobs.map(selectedJob => {
                    let matchingJob = jobMapping.find(job => { return job.ID == selectedJob });
                    return matchingJob ? matchingJob.JobFunction : '';
                })
            }
    
            // removes job functions that don't exist anymore
            selectedJobs = selectedJobs.filter(function (el) {
                return allJobs.indexOf(el) > -1;
            });
    
            this.setState({ ...this.state, selected_jobs: selectedJobs, is_loading: false });
            this.props.onJobFunctionsChange(selectedJobs);
        }
    }

    handleChange(event) {
        var jobFunction = event.target.value;
        var selectedJobs = this.state.selected_jobs;
        if (event.target.checked) {
            selectedJobs.push(jobFunction);
            this.setState({
                ...this.state,
                selected_jobs: selectedJobs
            });

        } else {
            var index = this.state.selected_jobs.indexOf(jobFunction);
            if (index > -1) {
                selectedJobs.splice(index, 1);

                this.setState({
                    ...this.state,
                    selected_jobs: selectedJobs
                });
            }
        }

        this.props.onJobFunctionsChange(selectedJobs);

    }

    arraysEqual = (a1, a2) => {
        return JSON.stringify(a1) === JSON.stringify(a2);
    };

    render() {
        var allJobs = JSON.parse(JSON.stringify(this.state.job_functions));
        var jobsArray = [], size = 10;

        while (allJobs.length > 0) {
            jobsArray.push(allJobs.splice(0, size));
        }

        if (!this.state.is_loading && jobsArray.length > 0) {
            return (
                <div className="job-functions">

                    <div className="job-function-column">
                        {jobsArray[0].map((job, index) =>
                            <label className="checkmark-container" key={index}>{job}
                                <input type="checkbox" checked={this.isChecked(job)} key={index} value={job} onChange={this.handleChange.bind(this)} />
                                <span className="checkmark"> </span>
                            </label>

                        )}
                    </div>

                    <div className="job-function-column">
                        {jobsArray[1].map((job, index) =>
                            <label className="checkmark-container" key={index}>{job}
                                <input type="checkbox" checked={this.isChecked(job)} key={index} value={job} onChange={this.handleChange.bind(this)} />
                                <span className="checkmark"> </span>
                            </label>

                        )}
                    </div>

                    <div className="job-function-column">
                        {jobsArray[2].map((job, index) =>
                            <label className="checkmark-container" key={index}>{job}
                                <input type="checkbox" checked={this.isChecked(job)} key={index} value={job} onChange={this.handleChange.bind(this)} />
                                <span className="checkmark"> </span>
                            </label>

                        )}
                    </div>
                </div>
            )
        } else {
            return null;
        }

    }
}

export default JobFunctionsCheckbox